import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes.js';

export default createRouter({
  routes,
  history: createWebHistory('/'),
});
